//
//
//
//
//
//
//
//
//
//

import videoHead from '../../../../views/activation/subscribe/videoHead'
    export default {
        name: "de",
        data(){
            return {
                isTmpl:false,
                playerOptions:{
                  height: document.body.clientWidth,
                  width: document.body.clientWidth,
                  autoplay: false,
                  muted: true,
                  language: 'en',
                  playbackRates: [0.7, 1.0, 1.5, 2.0],
                  sources: [{
                    type: "video/mp4",
                    // mp4
                    src: "",
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                  }],
                  poster: "",
                
                
                },
            }
        },
        props: {
          info: {
            type: Object,
          },
          imgSrc:{
            type: String,
            default() { return ''}
          },
          templateFlag:{
            type: String,
            default() { return ''}
          },
        },
        watch: {
          info:{ 
            handler(newVal, oldVal) {
              console.log('31313212312',this.imgSrc)
              if(this.playerOptions.poster  != this.imgSrc){
                this.$set(this.playerOptions,'poster',this.imgSrc)
                this.$set(this.playerOptions,'sources',{src:newVal.videoSrc,type: "video/mp4"})
              }
            },
            deep: true
          }
        },
        components: {
          videoHead,
        },
        created(){
          const tmplList = ['zh_tw','ta_tw']
          if (tmplList.includes(this.templateFlag)) {
            this.isTmpl = true
          }

        },
    }
